module.exports = __webpack_public_path__ + "img/gen.59c900f6.png";